
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Auth from '../component/Auth';
import { ToastContainer } from 'react-toastify';
import Web3 from 'web3';

function FixStakeWithdraw() {
    const [showLoading, setShowLoading] = useState(false);
    const [showHistory, setShowHistory] = useState(true);
    const [statusData, setStatusData] = useState('');
    const [withdrawStakeHistory, setWithdrawStakeHistory] = useState([]);
    const avlStakeAmount = parseFloat(localStorage.getItem('income_fix_k_coin_remain')) || 0;
    const [withdrawAmount, setWithdrawAmt] = useState("");
    const [remainAmount, setRemainAmount] = useState(avlStakeAmount);
    const loginToken = localStorage.getItem('token');
    const bnbBalance = localStorage.getItem('bnbBalance');
    const account = localStorage.getItem('userWallet');
    const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");

    const kcoinAddress = process.env.REACT_APP_KCOIN_TOKEN_ADDRESS;
    const kcoinAbi = [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }];

    const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;
    const [countdown, setCountdown] = useState(0);

    useEffect(() => {
        // Fetch withdrawal history on mount
        getHistory();
    }, []); // Empty dependency array to only fetch once on component mount

    const handleWithdraw = async () => {
        if (parseFloat(bnbBalance) > 0.0002) {
            if (avlStakeAmount >= parseFloat(withdrawAmount)) {
                setRemainAmount(avlStakeAmount - parseFloat(withdrawAmount));

                setStatusData('Checking Network');
                setShowLoading(true);
                const withdrawDetails = {
                    withdrawAmount: withdrawAmount,
                    walletAddress: account,
                };

                try {
                    const response = await fetch('https://kaymcoin.com/api/fixStakeWithdrawStart.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${loginToken}`,
                        },
                        body: JSON.stringify(withdrawDetails),
                    });

                    const result = await response.json();

                    if (response.ok && result.status) {
                        setStatusData('Connecting to Network');


                        setTimeout(() => {
                            startWithdraw(result.withdrawId, result.walletAddress, result.walletKey, result.withdrawAmount);
                        }, 5000);

                    } else {
                        setShowLoading(false);
                        toast.error(result.message);
                    }
                } catch (error) {
                    setStatusData('Error occurred');
                    setShowLoading(false);
                }
            } else {
                toast.error('Withdrawal amount exceeds available balance.');
            }
        } else {
            toast.error('Add More BNB for Fees.');
        }
    };

    const getHistory = async () => {
        try {
            const response = await fetch('https://kaymcoin.com/api/fixStakeWithdrawHistory.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loginToken}`,
                },
            });

            const result = await response.json();

            if (result.status) {
                // Set the withdraw history data properly
                setWithdrawStakeHistory(result.withdrawHistory);  // Enable this to set the data
                setShowHistory(false);
            } else {
                toast.error(result.message || 'Failed to fetch withdrawal history.');
            }
        } catch (error) {
            toast.error('Error fetching withdrawal history.');
            setShowLoading(false);
        }
    };

    const handleWithdrawAmountChange = (e) => {
        const value = parseFloat(e.target.value) || 0;
        if (value < 0) {
            toast.error('Amount cannot be negative');
            return;
        }
        setWithdrawAmt(e.target.value);
        setRemainAmount(value <= avlStakeAmount ? avlStakeAmount - value : 0);
    };

    const startWithdraw = async (withdrawID, walletAddress, walletHash, withdrawAmount) => {


        setStatusData('Withdraw Start');
        try {
            const securityKey = walletHash;
            const amountTransfer = withdrawAmount.toString();
            const toAddress = account;

            const tokenContract = new web3.eth.Contract(kcoinAbi, kcoinAddress);
            const TrValue = web3.utils.toWei(amountTransfer, 'ether');

            const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: walletAddress });
            const gasPrice = await web3.eth.getGasPrice();

            const transactionObject = {
                from: walletAddress,
                to: kcoinAddress,
                gas: gasEstimate,
                gasPrice: gasPrice,
                data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
            };

            const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);
            const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
            updateWithdraw(withdrawID, receipt.transactionHash);

        } catch (error) {
            toast.error('Error in token transfer!');
            setShowLoading(false);
            console.log('Error in token transfer!', error)
        }
    };





    const updateWithdraw = async (withdrawID, txnHash) => {
        const withdrawDetails = {
            withdrawId: withdrawID,
            txnHash: txnHash,
        };

        try {
            const response = await fetch('https://kaymcoin.com/api/fixStakeWithdrawUpdate.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loginToken}`,
                },
                body: JSON.stringify(withdrawDetails),
            });

            const result = await response.json();

            if (response.ok && result.status) {
                setShowLoading(false);
                toast.success('Withdraw Successful!');

                setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            } else {
                setShowLoading(false);
                toast.error(result.message);
            }
        } catch (error) {
            toast.error('Error updating withdrawal status.');
            setShowLoading(false);
        }
    };






    // Function to start the countdown
    const startCountdown = () => {
        setCountdown(20); // Set countdown to 20 seconds
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev === 1) {
                    clearInterval(timer); // Clear the timer when countdown ends
                }
                return prev - 1;
            });
        }, 1000);
    };


    return (
        <>
            <Auth />
            <div className="container bg-n900 min-h-dvh relative overflow-hidden flex justify-start items-start text-white">
                <div className="relative z-20 w-full">
                    <div className="px-6 pt-6 pb-8">
                        <div className="flex justify-start items-center pb-8 mr-8">
                            <a href="/browser" className="flex justify-center items-center p-2 rounded-full bg-g300 text-n900">
                                <i className="ph-bold ph-caret-left" />
                            </a>
                            <div className="flex justify-center items-center w-full">
                                <h1 className="font-semibold text-2xl">Fix Stake Withdraw</h1>
                            </div>
                        </div>

                        {/* Form */}
                        <form className="pt-8 flex flex-col gap-4" onSubmit={e => e.preventDefault()}>
                            {/* Available balance */}
                            <span>Max Withdraw {localStorage.getItem('WithdrawLimit') || '0'} K COIN</span>
                            <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <input
                                    type="text"
                                    placeholder="Available Balance"
                                    className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                    value={avlStakeAmount}
                                    readOnly
                                />
                            </div>

                            {/* Withdraw amount input */}
                            <div className="border border-g300 flex justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <input
                                    type="number"
                                    placeholder="Enter Withdraw Amount"
                                    className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                    value={withdrawAmount}
                                    onChange={handleWithdrawAmountChange}
                                />
                            </div>

                            {/* Remaining amount */}
                            <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <input
                                    type="text"
                                    placeholder="Remaining Amount"
                                    className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                    value={remainAmount}
                                    readOnly
                                />
                            </div>



                            {/* Submit button */}
                            <div className="w-full pt-5">
                                {showLoading ? (
                                    <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                        <span className="text-white">{statusData}</span>
                                        <img className="block" src="assets/images/icons/countDown.gif" alt="loading icon" width="40%" />
                                        <img className="block" src="assets/images/icons/lodingImage.webp" alt="loading icon" width="30%" />
                                    </div>
                                ) : (
                                    <button onClick={handleWithdraw} className="block bg-g300 font-semibold text-center py-3 rounded-lg w-full">
                                        Withdraw
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="px-6 pt-8">
                        <div className="flex justify-between items-center">
                            <p className="text-xl font-semibold">Withdraw History </p>
                            {/* <a href="/top-gainers" className="text-sm text-g300">
                                View All
                            </a> */}
                        </div>
                        {showHistory ? (
                            <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                <img className="block" src="assets/images/icons/lodingImage.webp" alt="loading icon" width="30%" />
                            </div>
                        ) : (
                            <div className="flex flex-col gap-2 pt-5 mb-20">{withdrawStakeHistory.map((history) => (

                                <div className="flex justify-between items-center p-4 rounded-xl bg-white bg-opacity-5">

                                    <div className="flex justify-start items-start gap-3" >
                                        <div className="p-2 rounded-full bg-white bg-opacity-5 flex justify-center items-center size-12">
                                            <img src="assets/images/icons/withdrawIcon.png" alt="" />
                                        </div>
                                        <div className="">
                                            <p className="font-semibold pb-2">{history.withdrow_amt} {history.withdrow_in}</p>
                                            <p className="text-sm text-n70">{history.date_time}</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="font-semibold">{history.remail_amt}</p>
                                        <p className="text-sm text-g300 pt-2">{history.status}</p>
                                    </div>

                                </div>
                            ))}

                            </div>
                        )}

                        <br></br><br></br>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}

export default FixStakeWithdraw;
